import React, { useEffect, useRef, useState } from 'react';

import { useStyles } from './style';
import { useConnectStripeMutation, useCreateStripeAccountMutation, useGetStripeLoginLinkMutation, useMeQuery } from '../../../../api/user';
import stripeLogo from '../../../../assets/images/stripeLogo.png';
import { useHistory, useLocation } from 'react-router-dom';
import { ThemedButton } from '../../../../shared/components/themed-button';

export const SupplierStripe: React.FC = () => {
  const classes = useStyles();
  const { search } = useLocation();
  const { replace } = useHistory();
  const code = search.split('code=')[1];
  const { data: user } = useMeQuery();
  const [connectLoading, setConnectLoading] = useState(false);

  const [getLoginLink] = useGetStripeLoginLinkMutation();
  const [createStripe] = useCreateStripeAccountMutation();
  const stripeLink = useRef<HTMLAnchorElement | null>(null);
  
  const isStripeConnected = user && 'stripe_user_id' in user && user?.stripe_user_id;
  const [connectStripe] = useConnectStripeMutation();

  useEffect(() => {
    code &&
      connectStripe(code).then(() => {
        replace('/account/billing/plans/stripe');
      });
  }, [code]);

  const onLoginStripe = () => {
    getLoginLink().then((res) => {
      if ('data' in res && res.data.success && stripeLink?.current) {
        if(res.data.login_link) {
          stripeLink.current!.href = res.data.login_link;
          stripeLink.current!.click();
        } else {
          onConnectStripe();
        }
      }
    });
  };

  const onConnectStripe = () => {
    setConnectLoading(true);
    createStripe().then((res) => {
      if ('data' in res && res.data.success && res.data.account_id) {
        window.location.href = res.data.onboarding_url;
      } else {
        setConnectLoading(false);
      }
    });
  };

  return (
    <div className={classes.supplierPmBox}>
      {isStripeConnected ? (
        <>
          <div className={classes.stripeTitle}>Your account is set up to receive credit card payments</div>
          <div className={classes.stripeSubText}>To edit your banking details please log into stripe</div>
          <div className={classes.loginStripBtn} onClick={onLoginStripe}>
            <img src={stripeLogo} alt='Stripe login' width={26} height={32} />
            <span>Stripe Login</span>
          </div>
        </>
      ) : (
        <>
          <div className={classes.stripeTitle}>Connect Stripe Account</div>
          <div className={classes.stripeSubText}>Connect Your Stripe Account for Easy Customer Payments Processing!</div>
          <ThemedButton onClick={onConnectStripe} disabled={connectLoading} title='Connect with Stripe' />
        </>
      )}
      <a href='' className={classes.hiddenLink} target='_blank' ref={stripeLink} />
    </div>
  );
};
